// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import { registerControllers } from "@radioactive-labs/plutonium";
registerControllers(application);

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import MobileMenuController from "./mobile_menu_controller";
application.register("mobile-menu", MobileMenuController);

import SlideshowController from "./slideshow_controller";
application.register("slideshow", SlideshowController);

import CollapsibleController from "./collapsible_controller";
application.register("collapsible", CollapsibleController);

import AccordionController from "./accordion_controller";
application.register("accordion", AccordionController);

import DropdownNavController from "./dropdown_nav_controller";
application.register("dropdown-nav", DropdownNavController);

import DashboardController from "./dashboard_controller";
application.register("dashboard", DashboardController);

import ShareController from "./share_controller";
application.register("share", ShareController);

import FaqController from "./faq_controller";
application.register("faq", FaqController);

import ModalController from "./modal_controller";
application.register("modal", ModalController);
